import { IGlobalState } from '../../reducers/interfaces/state';

export const getImpersonableState = (state: IGlobalState) => {
  const { impersonate } = state;
  return impersonate;
};